<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    base-modal#hrs-modal( :show='popup.configure' )
      modal-wrapper.max( @close='close' )
        template( v-slot:header )
          h5 {{$t("Set Available Hours")}} ({{ $t("Click to mark your break time")}})
        template( v-slot:contents )
          set-hrs( ref='hrs' :cfg='cfg' )

    #business-profile.view
      bf-notice( :message='message' @close='message = ""' )

      transition( name='appear' )
        bf-wrapper.max-960( v-show='show' )
          profile-header( :account='account' )

          form.business-profile.form(@submit.prevent='update')
            bf-flex.logo.centered(@click.native='$refs.upload.click()')
              input( type='file' ref='upload' style='display: none' accept='image/*' @change='upload( $event, "logo" )' )
              template( v-if='doc.logo || biz.logo' )
                .image-container
                  img( :src='doc.logo || biz.logo' )
              template(v-else)
                bf-flex.upload-container.centered
                  img( src='/ui/no-image.png' )
                  span {{ $t('Add Image') }}

            fieldset.fields
              label {{$t("Business Name")}}
              bf-input.basic
                input( type='text' v-model='doc.name' required )

              set-hrs-widget( ref='widget' v-if='biz.id' :initial='biz.cfg' @cfg='configure' )

              label {{ $t("Keyword")}} ({{$t("Press 'Enter' after each keyword")}})
              bf-input.basic
                vue-tags-input.category.labeled.basic( v-model='tag' :tags='doc.tags' @tags-changed='tags => doc.tags = tags' )

              label {{ $t("Address")}}
              bf-input.basic
                input(type='text' v-model='doc.address')

              label {{ $t("Phone")}}
              bf-input.basic
                input(type='phone' v-model='doc.phone')

              label {{ $t("Email")}}
              bf-input.basic
                input(type='email' v-model='doc.email')

              label {{ $t("Web Address")}}
              bf-input.basic
                input(type='text' v-model='doc.web')

              label {{ $t("Yelp ID")}}
              bf-input.basic
                input(type='text' v-model='doc.yelp')

              label {{ $t("Description")}}
              textarea(v-model='doc.description')

              bf-divider.section.borderless
              bf-flex.centered.save-button-wrapper
                bf-button.combo( type='submit' )
                  template(v-slot:text) {{ $route.params.thanks ? $t('Next - Dashboard') : $t('Save') }}

                bf-button.cancel(type='reset')
                  template(v-slot:text) {{ $t('Cancel') }}
    bf-modal#business-modal( :show='modal.show' )
      .container
        h4.heading {{$t("Thank You for Subscribing")}}
        p {{$t("Please enter your business information")}}
        p
          | {{$t("Business functions are located at the")}}
          span.emphasize {{$t("bottom")}}
          | {{$t("of the screen")}}
        p {{$t("There are 5 icons for")}}:
        ol
          li {{$t("Customer")}}
          li {{$t("Marketing")}}
          li {{$t("Dashboard")}}
          li {{$t("Selling")}}
          li {{$t("Orders")}}
        span.primary.acknowledge-button( @click='step++' ) {{$t("ACKNOWLEDGE")}}
      #highlight(v-if='modal.show')
</template>

<script>
  import { auth, db, str } from '@/main'
  import { View, Animatable } from '@/mixins/view'
  import ProfileHeader from '@/components/profile-header'
  import BaseModal from '@/components/modals/base'
  import ModalWrapper from '@/components/modals/wrapper'
  import SetHrs from '@/components/modals/set-hrs'
  import SetHrsWidget from '@/components/widgets/set-hrs'
  import VueTagsInput from '@johmun/vue-tags-input'

  export default {
    name: 'view.business-profile',

    components: {
      ProfileHeader,
      BaseModal,
      ModalWrapper,
      SetHrs,
      SetHrsWidget,
      VueTagsInput
    },

    mixins: [View, Animatable],

    props: ['user', 'account'],

    data() {
      return {
        doc: { hours: {}, web: 'http://', tags: [], name: '' },
        tag: '',
        collection: 'businesses',
        type: 'Business',
        password: {},
        step: 0,
        popup: { configure: false },
        cfg: null,
        message: ''
      }
    },

    computed: {
      modal() {
        return {
          show: !!this.$route.params.thanks && this.step == 0
        }
      }
    },

    watch: {
      biz( curr, prev ) {
        if ( curr.id ) {
          this.doc = curr
          if ( curr.cfg ) this.cfg = curr.cfg
          if ( !curr.web ) this.doc.web = 'http://'
        }
      },

      watch: {
        doc( curr, prev ) {
          this.$i18n.locale = this.account.locale
        }
      },
    },

    methods: {
      close() {
        this.cfg.closures = this.$refs.hrs.closures
        this.popup.configure = false
      },

      configure( cfg ) {
        this.cfg = cfg
        this.cfg.offset = new Date().getTimezoneOffset()
        this.popup.configure = true
      },

      update() {
        this.cfg = this.$refs.widget.cfg
        this.cfg.offset = new Date().getTimezoneOffset()
        this.set()
      },

      upload( e, field ) {
        let file = e.target.files[0]
        let reader  = new FileReader()
        reader.addEventListener('load', () => {
          const name = file.name
          let img = new Image()
          img.src = reader.result
          img.onload = () => {
            let width = img.width
            let height = img.height
            let ratio = img.width / img.height
            if( img.width > 100 ) {
              width = 100
              height = width / ratio
            }
            else if ( img.height > 100 ) {
              height = 100
              width = height * ratio
            }
            const elem = document.createElement('canvas')
            elem.width = width
            elem.height = height
            const ctx = elem.getContext('2d')
            ctx.drawImage( img, 0, 0, width, height )
            ctx.canvas.toBlob( blob => {
              const file = new File([blob], name, {
                type: 'image/jpeg',
                lastModified: Date.now()
              })

              let ref = str.ref( `/user/${this.user.uid}/logos/${file.name}` )
              ref.put(file).then( snap => {
                snap.ref.getDownloadURL().then( url => {
                  db.collection( 'businesses' ).doc( this.biz.id ).update({
                    logo: url
                  }).then( () => this.key++ )
                })
              }).catch( e => console.log(e) )
            }, 'image/jpeg', 1)
          }
          
        }, false)

        reader.readAsDataURL(file)
        
      },

      set() {
        let idref = db.collection( this.collection ).doc( this.doc.id )
        if ( this.doc.hours.opening > this.doc.hours.closing ) return this.message = 'Oops!  Did you make a mistake?  Cannot set opening time to later than closing time'
        idref.set({ ...this.doc, cfg: this.cfg }).then( doc => {
          this.message = `${ this.type } information saved!`
          this.$binding( 'doc', idref )
        })
      },  
    },

    created() {
      if ( this.biz.id ) {
        this.doc = this.biz
        if ( this.biz.cfg ) this.cfg = this.biz.cfg
        if ( !this.biz.web ) this.doc.web = 'http://'
      }
    }
  }
</script>

<style scoped lang='stylus'>
  #business-modal
    height calc( 100vh - var(--height-merchant-nav) )

  #highlight
    height var(--height-merchant-nav)
    position fixed
    bottom 0
    border 2px solid rgb( 240 160 80 )
    width 100vw
    box-sizing border-box

  #business-profile
    .bf-input
      background rgb(245 245 245)
      margin-top 5px
      margin-bottom 20px
      >>> .vue-tags-input, >>> .ti-input
        border 0
        background 0

  textarea
    background rgb(245 245 245)
    border solid 1px rgba(0 0 0 0.1)
    border-radius 5px
    padding 8px
    margin-bottom 10px
    width 97.5%

  label
    font-weight bold
    
  .fields
    background white
    padding 20px
    box-shadow var(--shadow-box)
    border-radius 5px

  .save-button-wrapper .bf-button
    margin 0 12px

  .logo
    margin 24px 0 16px 0
    .image-container
      width 88px
      height 88px
      img
        width 100%
        height 100%
        object-fit cover
        border 1px solid lightgray
        border-radius 50%
    .upload-container
      width 88px
      height 88px
      flex-direction column
      background rgb( 240 240 250 )
      border-radius 50%
      img
        width 20px
      span
        font-size .88em
        margin 8px 0
        font-weight bold

  #modal
    position fixed
    width 100vw
    height 100vh
    top 0
    left 0
    z-index 99
    background white
    color white
    align-items flex-start
    flex-direction column
    .close
      position absolute
      color white
      font-size 1.5em
      border 1px solid var(--clr-light)
      height 24px
      width 28px
      padding-bottom 4px
      display flex
      justify-content center
      border-radius 50%
      right 12px
      top 12px
    header
      position relative
      text-align center
      background var(--bg-nav)
      color white
      width 100%
      margin-bottom 96px
      padding 16px 0
      .heading
        color white
    main
      width 320px
      margin 0 auto
</style>
